var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdaptability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 140,
    viewBox: "0 0 158 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 157.193,
    height: 140,
    rx: 70,
    fill: "#F3E3E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_6150)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49.1228,
    cy: 57.7194,
    r: 8.47368,
    stroke: "#DD4F34",
    strokeWidth: 2.70175
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.825,
    y: 50.4738,
    width: 14.4912,
    height: 14.4912,
    stroke: "#DD4F34",
    strokeWidth: 2.70175
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3197 108.255L79.2106 91.1229L89.1015 108.255H69.3197Z",
    stroke: "#DD4F34",
    strokeWidth: 2.70175
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.011 72.9935L109.794 72.8276L111.011 72.9935ZM106.275 88.3279L107.373 88.8771L106.275 88.3279ZM103.835 91.2657C104.05 91.9091 104.745 92.2569 105.388 92.0424L115.874 88.5472C116.517 88.3327 116.865 87.6372 116.651 86.9937C116.436 86.3503 115.741 86.0026 115.097 86.2171L105.777 89.3239L102.67 80.0036C102.455 79.3601 101.76 79.0124 101.117 79.2269C100.473 79.4413 100.125 80.1368 100.34 80.7803L103.835 91.2657ZM110.537 67.3782L109.794 72.8276L112.228 73.1593L112.97 67.7098L110.537 67.3782ZM105.176 87.7787L103.902 90.3281L106.099 91.4265L107.373 88.8771L105.176 87.7787ZM109.794 72.8276C109.085 78.0307 107.525 83.0818 105.176 87.7787L107.373 88.8771C109.842 83.9394 111.482 78.6292 112.228 73.1593L109.794 72.8276Z",
    fill: "#DD4F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5106 98.3244L60.7561 99.2933L61.5106 98.3244ZM51.3811 87.641L52.3889 86.9391L52.3889 86.9391L51.3811 87.641ZM49.5747 83.528C48.9071 83.4086 48.269 83.853 48.1496 84.5206L46.2032 95.4005C46.0838 96.0682 46.5282 96.7063 47.1958 96.8257C47.8635 96.9451 48.5015 96.5007 48.621 95.8331L50.3511 86.1621L60.0221 87.8922C60.6897 88.0116 61.3278 87.5672 61.4472 86.8996C61.5667 86.2319 61.1223 85.5939 60.4546 85.4744L49.5747 83.528ZM67.6842 101.575L62.2651 97.3554L60.7561 99.2933L66.1752 103.513L67.6842 101.575ZM52.3889 86.9391L50.3662 84.035L48.3507 85.4388L50.3734 88.3429L52.3889 86.9391ZM62.2651 97.3554C58.4685 94.3991 55.139 90.8876 52.3889 86.9391L50.3734 88.3429C53.2646 92.4938 56.7648 96.1855 60.7561 99.2933L62.2651 97.3554Z",
    fill: "#DD4F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5673 45.5022L59.8691 44.4919L59.8691 44.4919L60.5673 45.5022ZM79.0784 37.7018L79.3139 38.9071L79.3139 38.9071L79.0784 37.7018ZM80.8074 38.2489C81.1862 37.6863 81.0371 36.9231 80.4745 36.5444L71.3058 30.3721C70.7432 29.9934 69.9801 30.1424 69.6013 30.7051C69.2225 31.2677 69.3716 32.0309 69.9342 32.4096L78.0841 37.896L72.5977 46.046C72.219 46.6086 72.368 47.3718 72.9307 47.7505C73.4933 48.1293 74.2564 47.9802 74.6352 47.4176L80.8074 38.2489ZM57.8034 48.9052L61.2655 46.5125L59.8691 44.4919L56.407 46.8846L57.8034 48.9052ZM79.3139 38.9071L80.0241 38.7684L79.5533 36.3578L78.843 36.4965L79.3139 38.9071ZM61.2655 46.5125C66.6936 42.7612 72.8381 40.172 79.3139 38.9071L78.843 36.4965C72.0352 37.8263 65.5755 40.5483 59.8691 44.4919L61.2655 46.5125Z",
    fill: "#DD4F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3508 38.0703C89.035 39.0937 101.684 44.9475 105.614 50.351",
    stroke: "#DD4F34",
    strokeWidth: 2.70175
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.93 94.5615C99.2128 97.252 92.6063 101.814 85.9649 102.544",
    stroke: "#DD4F34",
    strokeWidth: 2.70175
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9125 80.1462C46.7862 76.4921 45.4835 71.3121 47.9125 65.0879",
    stroke: "#DD4F34",
    strokeWidth: 2.70175
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_6150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.5965,
    height: 81.0526,
    fill: "white",
    transform: "translate(39.2982 29.4737)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptability);
export default __webpack_public_path__ + "static/media/adaptability.9bc2758b2b7542affa6adf9b56ee4e5b.svg";
export { ForwardRef as ReactComponent };